import { createFileRoute } from '@tanstack/react-router'
import { InterviewPage } from '@/features/interview/components/interview-page'

export const Route = createFileRoute('/interview/$token')({
  component: InterviewPage,
})
